// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { LaneDirectionJson, ILaneDirectionJson } from "./Reports.LaneDirectionJson.gen";
import { DirectionNameJson, IDirectionNameJson } from "./Reports.DirectionNameJson.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";
import { FHWAClasses } from "./Shared.FHWAClasses.gen";
import { AggregatedTargetAttribute } from "./Reports.AggregatedTargetAttribute.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface ITurningMovementReportConfiguration {
	filterTypes: TargetTypes | undefined | number ;

	filterClasses: FHWAClasses | undefined;

	lanes: ILaneDirectionJson[] | undefined;

	streetNames: IDirectionNameJson[] | undefined;

	inclusiveStart: string;

	exclusiveEnd: string;

	grouping: AggregatedTargetAttribute;

	facilityIds: string[] | undefined;

	deviceIds: string[] | undefined;

	groupingValues: number[];

	$type?: string | undefined;
}
export class TurningMovementReportConfiguration {
	constructor(data?: ITurningMovementReportConfiguration) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.lanes = data.lanes ? data.lanes.map((l: any) => new LaneDirectionJson(l)) : [];
		this.streetNames = data.streetNames ? data.streetNames.map((s: any) => new DirectionNameJson(s)) : [];
		this.inclusiveStart = new Date(data.inclusiveStart);
		this.exclusiveEnd = new Date(data.exclusiveEnd);
	}

	filterTypes: TargetTypes | undefined | number ;

	filterClasses: FHWAClasses | undefined;

	lanes: LaneDirectionJson[] | undefined = [];

	streetNames: DirectionNameJson[] | undefined = [];

	@IsNotEmpty()
	inclusiveStart: Date = new Date();

	@IsNotEmpty()
	exclusiveEnd: Date = new Date();

	grouping: AggregatedTargetAttribute = 0;

	facilityIds: string[] | undefined;

	deviceIds: string[] | undefined;

	groupingValues: number[] = [];

	static $type: string = "CoreApi.Models.Reports.TurningMovementReportConfiguration, ";
	$type?: string | undefined = TurningMovementReportConfiguration.$type;
}

